$( window ).on( "load", function() {
	$( ".about__info--more a" ).click( function( e ) {
		e.preventDefault();
		if ( !$( this ).hasClass( "about__info-more--active" ) ) {
			$( this ).addClass( "about__info-more--active" );
			$( this ).children( ".about__info-more--title" ).text( "Show Less" );
			$( ".about__info--desc--hidden" ).slideDown();
		} else {
			$( this ).removeClass( "about__info-more--active" );
			$( this ).children( ".about__info-more--title" ).text( "Show More" );
			$( ".about__info--desc--hidden" ).slideUp();
			let id  = $( this ).attr( "href" );
			let	top = $( id ).offset().top;
			$( "body,html" ).animate( { scrollTop: top }, 300 );
		}
	} );
} );
